import React, { useState, useEffect } from "react";
import hiveLeft from "images/landing-page/hive-left.png";
import hiveRight from "images/landing-page/hive-right.png";
import BusinessModal from "./../components/BusinessForm";
import SuccessModal from "./../components/SuccessModal";

const MainHeader = () => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  return (
    <>
      <div className="header-background"></div>

      <img
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          minWidth: 347,
          width: "20%",
          zIndex: -1,
        }}
        src={hiveLeft}
      />

      <img
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          minWidth: 347,
          width: "20%",
          zIndex: -1,
        }}
        src={hiveRight}
      />

      <div className="margin-100-zero" style={{ textAlign: "center" }}>
        <div className="header-title" style={{ marginBottom: 30 }}>
          {"Siųsk siuntas į Amazon sandėlius pigiau ir greičiau"}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 29,
          }}
        >
          <p className="text-font" style={{ maxWidth: 880 }}>
            
            Siuntų siuntimas iš Lietuvos į Amazon sandėlius JAV tik nuo
            &nbsp;
            <strong>3,45 Eur/kg.</strong>
            <br/>
            Kaina nurodyta siunčiant 70 kg ir daugiau.
            <br/>
            Pristatome vos per
            &nbsp;
            <strong>2-5 d.d. </strong>
            <br/>
            <br/>
            Susisiekime, pateiksime asmeninį pasiūlymą!
          </p>
        </div>
        <div
          style={{
            maxWidth: 600,
            margin: "auto auto 30px auto",
          }}
        >
          <img src="/images/amazon_jav.png" style={{ width: '100%' }} alt=" Siuntų siuntimas iš Lietuvos į Amazon sandėlius JAV"></img>
        </div>
        <button
          className="btn btn-primary-alsendo btn-lg btn-circle"
          onClick={() => {
            setIsFormModalVisible(true);
          }}
        >
          {"Gauti pasiūlymą"}
        </button>
      </div>
      {isFormModalVisible && (
        <BusinessModal
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  );
};

export default MainHeader;
